import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconVideo = props => {
  const $ = _c(7);
  const color = props.color || "#585858";
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11.5 0A11.5 11.5 0 1023 11.5 11.516 11.516 0 0011.5 0zm0 21.62A10.123 10.123 0 011.38 11.5 10.123 10.123 0 0111.5 1.38 10.123 10.123 0 0121.62 11.5 10.134 10.134 0 0111.5 21.62z" />;
    t1 = <path d="M15.58 11.871l-6.677 3.71V8.16z" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color) {
    t2 = <g fill={color} fillRule="nonzero">{t0}{t1}</g>;
    $[2] = color;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== t2) {
    t3 = <svg width={23} height={23} {...props}>{t2}</svg>;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
IconVideo.propTypes = {
  color: PropTypes.string
};
export default IconVideo;